import { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';

const services = [
  {
    id: 'web',
    icon: 'ri-layout-4-line',
    title: 'WEBサイト制作',
    subtitle: 'Web Design & Development',
    description:
      'コーポレートサイト・ランディングページ・ECサイトまで、デザインから実装まで一貫対応。集客・成約につながる戦略的なWEBサイトを、丁寧なヒアリングをもとに制作します。',
    tags: ['コーポレートサイト', 'LP制作', 'ECサイト', 'WordPress'],
    bg: '#F5F8FF',
    accent: '#1E6FFF',
    image: 'https://readdy.ai/api/search-image?query=modern%20web%20design%20workspace%20with%20laptop%20displaying%20elegant%20website%20mockup%2C%20clean%20minimalist%20desk%20setup%2C%20soft%20blue%20ambient%20lighting%2C%20professional%20digital%20agency%20atmosphere%2C%20floating%20UI%20elements%20and%20code%20snippets%2C%20tech%20startup%20aesthetic%2C%20dark%20navy%20blue%20and%20white%20color%20scheme%2C%20high-end%20corporate%20website%20design%20on%20screen%2C%20creative%20professional%20environment%2C%20no%20people&width=800&height=500&seq=service-web-design-01&orientation=landscape',
    pricing: [
      { name: 'ランディングページ', price: '¥50,000〜', note: '1ページ完結型' },
      { name: 'コーポレートサイト', price: '¥150,000〜', note: '5〜10ページ標準構成' },
      { name: 'ECサイト', price: '¥250,000〜', note: 'カート・決済機能込み' },
      { name: '月額保守・管理', price: '¥5,000〜/月', note: 'セキュリティ・更新対応' },
    ],
    flow: [
      { step: '01', label: 'ヒアリング', desc: '事業内容・目標・競合・ターゲット層を丁寧にヒアリング' },
      { step: '02', label: '設計・デザイン', desc: 'ワイヤーフレーム作成後、ブランドに合ったデザインを提案' },
      { step: '03', label: '実装・開発', desc: 'コーディングおよびCMS構築。スマホ対応も標準対応' },
      { step: '04', label: '公開・引き渡し', desc: '最終確認後に公開。運用マニュアルもご提供します' },
    ],
  },
  {
    id: 'sns',
    icon: 'ri-instagram-line',
    title: 'SNS運用代行',
    subtitle: 'Social Media Management',
    description:
      'Instagram・X（旧Twitter）・Facebookの投稿企画・制作・分析をまるごとお任せ。ブランドの世界観を守りながら、フォロワー増加・エンゲージメント向上を実現します。',
    tags: ['Instagram', 'X / Twitter', 'Facebook', 'コンテンツ制作'],
    bg: '#EEF4FF',
    accent: '#0099FF',
    image: 'https://readdy.ai/api/search-image?query=social%20media%20management%20concept%20with%20multiple%20screens%20showing%20Instagram%20and%20Twitter%20feeds%2C%20engagement%20graphs%20and%20follower%20growth%20charts%2C%20professional%20digital%20agency%20workspace%2C%20soft%20blue%20ambient%20lighting%2C%20dark%20navy%20blue%20background%20with%20glowing%20cyan%20and%20electric%20blue%20accents%2C%20floating%20social%20media%20icons%20and%20analytics%20metrics%2C%20tech%20corporate%20atmosphere%2C%20futuristic%20marketing%20technology%20aesthetic%2C%20no%20people&width=800&height=500&seq=service-sns-tech-navy-2026&orientation=landscape',
    pricing: [
      { name: 'ライトプラン', price: '¥19,800〜/月', note: '月8投稿・レポート付き' },
      { name: 'スタンダードプラン', price: '¥29,800〜/月', note: '月12投稿・戦略MTG込み' },
      { name: 'プレミアムプラン', price: '¥49,800〜/月', note: '月16投稿＋広告運用込み' },
      { name: '写真・動画撮影', price: '¥30,000〜/回', note: '撮影・編集・素材提供' },
    ],
    flow: [
      { step: '01', label: 'ヒアリング・戦略設計', desc: 'ターゲット・競合・投稿方針・トーン＆マナーを策定' },
      { step: '02', label: 'コンテンツ制作', desc: '投稿画像・キャプション・ハッシュタグを月次で一括制作' },
      { step: '03', label: '投稿・運用', desc: '最適な時間帯に投稿。コメント・DM対応も対応可能' },
      { step: '04', label: '分析・改善', desc: '月次レポートで数値を振り返り、翌月の施策に反映' },
    ],
  },
  {
    id: 'marketing',
    icon: 'ri-bar-chart-grouped-line',
    title: 'デジタルマーケティング',
    subtitle: 'Digital Marketing',
    description:
      'SEO対策・Web広告（Google/Meta）・MEO対策など、デジタル集客の施策を総合的にサポート。データ分析に基づいたPDCAで、費用対効果の高いマーケティングを実行します。',
    tags: ['SEO対策', 'MEO対策', 'Google広告', 'Meta広告'],
    bg: '#F5F8FF',
    accent: '#1E6FFF',
    image: 'https://readdy.ai/api/search-image?query=digital%20marketing%20analytics%20dashboard%20with%20growth%20charts%20and%20data%20visualization%2C%20modern%20business%20intelligence%20interface%2C%20floating%20SEO%20and%20performance%20metrics%2C%20professional%20marketing%20strategy%20concept%2C%20soft%20blue%20ambient%20lighting%2C%20tech%20corporate%20atmosphere%2C%20data-driven%20decision%20making%20aesthetic%2C%20navy%20blue%20and%20cyan%20color%20scheme%2C%20abstract%20digital%20network%20connections%2C%20futuristic%20marketing%20technology%2C%20no%20people&width=800&height=500&seq=service-digital-marketing-01&orientation=landscape',
    pricing: [
      { name: 'MEO対策', price: '¥20,000〜/月', note: 'Googleマップ・口コミ最適化' },
      { name: 'SEO対策', price: '¥20,000〜/月', note: 'キーワード選定・記事制作含む' },
      { name: 'Web広告運用', price: '¥50,000〜/月', note: '広告費別途・レポート付き' },
      { name: 'ホットペッパー最適化', price: '¥15,000〜/月', note: 'プロフィール・写真・予約改善' },
    ],
    flow: [
      { step: '01', label: '現状分析', desc: '既存サイト・SNS・口コミの現状を数値で把握・課題抽出' },
      { step: '02', label: '施策立案', desc: '課題と目標に応じた最適なデジタル集客施策を設計' },
      { step: '03', label: '実施・運用', desc: '施策を実装し、広告・SEO・MEOの運用を開始' },
      { step: '04', label: 'レポート・改善', desc: '月次レポートで成果を共有し、PDCAを高速で回す' },
    ],
  },
];

export default function Services() {
  const sectionRef = useRef<HTMLDivElement>(null);
  const [openFlow, setOpenFlow] = useState<string | null>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.querySelectorAll('.srv-fade').forEach((el, i) => {
              setTimeout(() => {
                (el as HTMLElement).classList.add('opacity-100', 'translate-y-0');
                (el as HTMLElement).classList.remove('opacity-0', 'translate-y-8');
              }, i * 100);
            });
          }
        });
      },
      { threshold: 0.1 }
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section id="services" className="py-28 bg-white" ref={sectionRef}>
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        {/* Header */}
        <div className="srv-fade opacity-0 translate-y-8 transition-all duration-700 mb-16 md:mb-20">
          <p className="text-[#1E6FFF] text-xs tracking-[0.3em] mb-4 uppercase">/ Services</p>
          <h2 className="text-4xl md:text-5xl font-bold text-[#0A1628] tracking-tight leading-tight mb-5">
            提供サービス
          </h2>
          <p className="text-[#666] text-lg leading-relaxed max-w-xl">
            WEBサイト制作からSNS運用・デジタルマーケティングまで、<br className="hidden md:block" />
            ビジネス成長を加速させる支援を行っています。
          </p>
        </div>

        {/* Service Blocks */}
        <div className="space-y-10">
          {services.map((s) => (
            <div
              key={s.id}
              id={s.id}
              className="srv-fade opacity-0 translate-y-8 transition-all duration-700 rounded-2xl overflow-hidden"
              style={{ backgroundColor: s.bg, border: '1px solid rgba(30,111,255,0.1)' }}
            >
              {/* Service Image Banner */}
              <div className="relative h-56 md:h-64 overflow-hidden">
                <img
                  src={s.image}
                  alt={s.title}
                  className="w-full h-full object-cover object-center transition-transform duration-700 hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/20 to-transparent" />
                <div className="absolute bottom-0 left-0 p-8 md:p-12">
                  <div className="flex items-center gap-4">
                    <div
                      className="w-12 h-12 flex items-center justify-center rounded-xl shrink-0"
                      style={{ background: 'linear-gradient(135deg, #1E6FFF, #0099FF)' }}
                    >
                      <i className={`${s.icon} text-xl text-white`} />
                    </div>
                    <div>
                      <p className="text-[#4DA3FF] text-xs tracking-[0.2em] uppercase">{s.subtitle}</p>
                      <h3 className="text-2xl font-bold text-white">{s.title}</h3>
                    </div>
                  </div>
                </div>
              </div>

              {/* Top Section */}
              <div className="p-8 md:p-12 grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16">
                {/* Left: Overview */}
                <div>
                  <p className="text-[#555] text-sm leading-relaxed mb-6">{s.description}</p>
                  <div className="flex flex-wrap gap-2">
                    {s.tags.map((tag) => (
                      <span
                        key={tag}
                        className="text-xs px-3 py-1 rounded-full bg-white text-[#1E6FFF]"
                        style={{ border: '1px solid rgba(30,111,255,0.25)' }}
                      >
                        {tag}
                      </span>
                    ))}
                  </div>
                </div>

                {/* Right: Pricing */}
                <div>
                  <p className="text-xs tracking-[0.25em] text-[#888] uppercase mb-4">/ 料金目安</p>
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                    {s.pricing.map((p) => (
                      <div key={p.name} className="bg-white rounded-xl p-4" style={{ border: '1px solid rgba(30,111,255,0.08)' }}>
                        <p className="text-[11px] text-[#888] mb-1">{p.name}</p>
                        <p className="text-lg font-bold text-[#0A1628] leading-tight">{p.price}</p>
                        <p className="text-[11px] text-[#999] mt-1">{p.note}</p>
                      </div>
                    ))}
                  </div>
                  <p className="text-xs text-[#aaa] mt-3 leading-relaxed">
                    ※ 上記は目安価格です。規模・要件により異なります。詳細はお気軽にご相談ください。
                  </p>
                </div>
              </div>

              {/* Flow Toggle */}
              <div style={{ borderTop: '1px solid rgba(30,111,255,0.1)' }}>
                <button
                  type="button"
                  onClick={() => setOpenFlow(openFlow === s.id ? null : s.id)}
                  className="w-full flex items-center justify-between px-8 md:px-12 py-5 cursor-pointer hover:bg-white/50 transition-colors"
                >
                  <span className="text-sm font-medium text-[#0A1628] tracking-wide flex items-center gap-2">
                    <i className="ri-route-line text-[#1E6FFF]" />
                    支援フロー（ご依頼の流れ）を見る
                  </span>
                  <i className={`ri-arrow-down-s-line text-[#888] text-lg transition-transform duration-300 ${openFlow === s.id ? 'rotate-180' : ''}`} />
                </button>

                {/* Flow Steps */}
                <div
                  className={`overflow-hidden transition-all duration-500 ${openFlow === s.id ? 'max-h-96' : 'max-h-0'}`}
                >
                  <div className="px-8 md:px-12 pb-8 md:pb-10">
                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
                      {s.flow.map((f, idx) => (
                        <div key={f.step} className="relative">
                          {idx < s.flow.length - 1 && (
                            <div className="hidden lg:block absolute top-5 left-full w-full h-px z-0" style={{ background: 'rgba(30,111,255,0.2)', width: 'calc(100% - 2rem)' }} />
                          )}
                          <div className="bg-white rounded-xl p-5 relative z-10" style={{ border: '1px solid rgba(30,111,255,0.08)' }}>
                            <div
                              className="w-8 h-8 flex items-center justify-center rounded-full text-white text-xs font-bold mb-3"
                              style={{ background: 'linear-gradient(135deg, #1E6FFF, #0099FF)' }}
                            >
                              {f.step}
                            </div>
                            <p className="text-sm font-bold text-[#0A1628] mb-2">{f.label}</p>
                            <p className="text-xs text-[#666] leading-relaxed">{f.desc}</p>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Bottom Note */}
        <div
          className="srv-fade opacity-0 translate-y-8 transition-all duration-700 mt-14 rounded-2xl p-8 md:p-12 flex flex-col md:flex-row items-start md:items-center justify-between gap-6"
          style={{ background: 'linear-gradient(135deg, #020B18 0%, #0A1E3D 100%)', border: '1px solid rgba(30,111,255,0.2)' }}
        >
          <div>
            <p className="text-[#4DA3FF] text-xs tracking-[0.3em] mb-2 uppercase">/ Free Consultation</p>
            <h4 className="text-xl md:text-2xl font-bold text-white mb-2">
              まずは無料でご相談ください
            </h4>
            <p className="text-white/50 text-sm leading-relaxed">
              予算・スケジュール・ご要望など、お気軽にお問い合わせください。
            </p>
          </div>
          <Link
            to="/contact"
            className="shrink-0 text-white px-8 py-4 rounded-full text-sm tracking-widest font-bold hover:opacity-90 hover:scale-105 transition-all duration-300 whitespace-nowrap"
            style={{ background: 'linear-gradient(90deg, #1E6FFF 0%, #0099FF 100%)' }}
          >
            無料相談を申し込む
          </Link>
        </div>
      </div>
    </section>
  );
}
